import iconEmailClock from '../../../../assets/icons/icon_email_clock.svg';
import iconEmailHourglass from '../../../../assets/icons/icon_email_hourglass.svg';
import iconNofileDownloaded from '../../../../assets/icons/icon_no-file-downloaded.svg';

export const HEADER_ADERENCIA_PRECOS = {
  title: 'Aderência de preços',
  subtitle: 'Monitore, analise e garanta que os preços praticados estejam alinhados com sua estratégia.',
};

export const NOTIFICATION_PENDING_UPDATE = {
  title: 'Atenção: há uma atualização pendente.',
  description: 'O arquivo atual será processado até amanhã. Enquanto isso, o painel exibido abaixo corresponde ao seu último envio.',
};

export const PAGE_BLOCKER = {
  title: 'Analise o mercado e garanta que seus preços estejam sendo praticados como o planejado.',
  subtitle: 'Disponível em outros planos do InfoPanel.',
  modal: {
    title: 'Acompanhe de perto o mercado e saiba se os seus preços estão sendo aplicados como planejado.',
    subtitle: 'Converse com um de nossos especialistas e descubra todos os benefícios do módulo de Aderência de Preços.',
  },
};

export const FILTER_LOCALE = {
  noResultsText: 'Nenhum item encontrado',
  searchPlaceholder: 'Buscar item',
};

export const OPTIONS_DROPDOWN = [
  {
    key: 'CSV',
    label: 'Download em CSV',
  },
  {
    key: 'XLSX',
    label: 'Download em XLS',
  },
];

export const FILTER_NAMES = {
  PRODUTO: 'produto',
  REDE: 'rede',
  TIPO_LOJA: 'tipoLoja',
  UF: 'uf',
  SEGMENTO: 'segmento',
};

export const ADERENCIA_BODY_REQUEST_NAMES = {
  PRODUTO: 'produto',
  REDE: 'rede',
  TIPO_LOJA: 'tipoLoja',
  UF: 'uf',
  SEGMENTO: 'segmentosPersonalizados',
};

export const DETAILING_FILTER_NAMES = {
  PRODUTO: 'produtoDetailing',
  REDE: 'redeDetailing',
  TIPO_LOJA: 'tipoLojaDetailing',
  UF: 'ufDetailing',
};

export const LENGTH_MENU = [
  {
    value: 10,
    label: 10,
  },
  {
    value: 20,
    label: 20,
  },
];

export const TRACK_EVENT_FILTER_NAMES = {
  PRODUTO: 'Filtro de produto',
  REDE: 'Filtro de rede',
  TIPO_LOJA: 'Filtro de tipo de loja',
  UF: 'Filtro de UF',
};

export const FILE_DOWNLOAD_STATUS = {
  willReceiveByEmail: {
    title: 'Você receberá o arquivo por e-mail',
    message: 'Precisamos de um tempo para processar as informações solicitadas. Te enviaremos um e-mail quando o arquivo estiver disponível para download.',
    confirmButton: null,
    cancelButton: null,
    icon: iconEmailClock,
    cancelBtnWidth: null,
    confirmBtnWidth: null,
    closeButton: true,
  },
  willDelay: {
    title: 'O envio do arquivo pode demorar mais de 20 minutos',
    message: 'Sua solicitação possui uma grande quantidade de dados. Te enviaremos um e-mail quando o arquivo estiver disponível para download.',
    confirmButton: null,
    cancelButton: null,
    icon: iconEmailHourglass,
    cancelBtnWidth: '200px',
    confirmBtnWidth: '200px',
    closeButton: true,
  },
  willNotDownload: {
    title: 'A solicitação é muito grande para ser processada',
    message: 'Não é possível fazer download de arquivos com mais de 1 milhão de linhas. Revise os filtros e tente novamente.',
    confirmButton: 'REVISAR FILTROS',
    cancelButton: 'FECHAR',
    icon: iconNofileDownloaded,
    cancelBtnWidth: '200px',
    confirmBtnWidth: '200px',
    closeButton: false,
  },
  noDataForDownload: {
    title: 'Nenhum resultado encontrado',
    message: 'Não foram encontrados dados para download. Revise os filtros e tente novamente.',
    confirmButton: null,
    cancelButton: null,
    icon: iconNofileDownloaded,
    cancelBtnWidth: '200px',
    confirmBtnWidth: '200px',
    closeButton: true,
  },
};

export const UF_FILTER_VALUE_ALIASES: Record<string, string> = {
  'grande sp': 'GRANDE_SP',
  'sp interior': 'SP_INTERIOR',
};

export const UF_FILTER_DISPLAY_LABELS: Record<string, string> = {
  GRANDE_SP: 'Grande SP',
  SP_INTERIOR: 'SP interior',
};
